var App = App || {};

App.SiteCookieNotice = (function ($) {
    'use strict';

    function init() {

        var Notice = $(".site-cookie-notice");
        var Confirm = Notice.find("[data-cookieNotice='confirm']");
        var siteFooter = $(".site-footer");

        if (Confirm.length) {
            siteFooter.addClass("cookie-notice-showing");
        }

        Confirm.click(function () {
            Notice.addClass("animate__animated animate__fadeOutDown").attr("aria-hidden", true).find("a, button").attr("tabindex", "-1");
            App.Cookies.setItem("CookieNotice", "confirmed", Infinity, "/", window.location.hostname, window.location.protocol === "https:");
            siteFooter.removeClass("cookie-notice-showing");
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.SiteCookieNotice.init();
});